import React, { FC } from "react";

import DocumentLink from "@/components/DocumentLink/DocumentLink";
import MediaHighlightDualColumn from "@/components/MediaHighlightDualColumn/MediaHighlightDualColumn";
import Icon from "@/components/ui/Icon/Icon";
import { IDocumentListingProps } from "@/types";

function DocumentListing(props: IDocumentListingProps) {
  const { internalName, description, documents } = props.entry;
  if (!documents || documents.length == 0) return null;
  return (
    <>
      <section className="bg-gray-100 py-12 px-4 sm:px-6 lg:px-8 mt-4xl container">
        <h2 className="font-primary uppercase text-l md:text-xl mb-xl md:mb-l font-medium text-center">{internalName}</h2>
        <div className="p-6 md:w-[646px] mx-auto">
          {description && <p className="text-gray-600 mb-4xl whitespace-pre-wrap" dangerouslySetInnerHTML={{ __html: description.html }} />}{" "}
          <div className="border-b border-b-gray-10 md:pt-[48px]">
            {documents.map((document, index) => (
              <DocumentLink key={index} {...document} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default DocumentListing;
